import { getTextEditing, mountSelectorAt } from 'utils/selectors';

const mount = mountSelectorAt('feedback');

export const getFeedbackSubject = mount(localState => localState.subject);

export const getFeedbackTextEditing = mount(localState => getTextEditing(localState.textEditing));

export const getFeedbackEmojis = mount(localState => localState.emojis);



/** WEBPACK FOOTER **
 ** ./src/members/state/feedback/selectors.js
 **/